import React from 'react';
import { Sparkles, Palette, Layout, Wand2, Image, Layers, Brush } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
export function CreativeExperiences() {
  return <ServicePage badgeText="CREATIVE EXPERIENCES" badgeIcon={<Sparkles className="w-3.5 h-3.5" data-id="element-364" />} titleStart="Design that" titleAccent="moves people" titleAccentColor="purple" subtitle="From brand identity to product UX, we craft creative experiences that connect with users and convert. Beautifully designed, thoughtfully built." heroIcon={Sparkles} heroIconColor="text-brand-purple" heroIconBg="bg-purple-50" checklist={['Brand strategy & identity', 'Product UX & UI design', 'Motion & micro-interactions', 'Design systems at scale']} features={[{
    title: 'Brand Identity',
    description: 'Logos, visual systems, and brand guidelines that build instant recognition and trust.',
    icon: Palette
  }, {
    title: 'UX/UI Design',
    description: 'User flows, wireframes, and pixel-perfect interfaces designed around real user needs.',
    icon: Layout
  }, {
    title: 'Design Systems',
    description: 'Scalable component libraries and tokens that keep your product consistent as it grows.',
    icon: Layers
  }, {
    title: 'Motion Design',
    description: 'Tasteful animations and transitions that delight users and reinforce your brand.',
    icon: Wand2
  }, {
    title: 'Creative Direction',
    description: 'Strategic visual direction across campaigns, web, and product touchpoints.',
    icon: Brush
  }, {
    title: 'Visual Content',
    description: 'Illustrations, icons, and marketing visuals that elevate every touchpoint.',
    icon: Image
  }]} processSteps={[{
    number: '01',
    title: 'Discover',
    description: 'Workshops to understand your brand, audience, and business goals.'
  }, {
    number: '02',
    title: 'Define',
    description: 'Strategy, moodboards, and a clear creative direction approved by stakeholders.'
  }, {
    number: '03',
    title: 'Design',
    description: 'High-fidelity designs and prototypes iterated with your feedback.'
  }, {
    number: '04',
    title: 'Deliver',
    description: 'Production-ready assets, guidelines, and ongoing support.'
  }]} ctaTitle="Ready to elevate your brand?" ctaSubtitle="Let's craft a creative experience your users will love." data-id="element-363" />;
}